import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
export var ApplicationLauncherText = function ApplicationLauncherText(_a) {
  var _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      children = _a.children,
      props = __rest(_a, ["className", "children"]);

  return React.createElement("span", Object.assign({
    className: css('pf-c-app-launcher__menu-item-text', className)
  }, props), children);
};